<template>
  <div class="category-warp">
    <div class="category-filter filter-fixed" :style="{'top': fixedTop}">
      <div v-for="item in filterTab" :key="item.id">
        <div
          class="tab-item"
          :class="{'active': curType == item.type || (fnChangeFlag && item.type == 'filter')}"
          @click="changeTab(item)"
        >
          <span>{{item.name}}</span>
          <img :src="`${$cdnImageUrl}/search/zonghe_blue.png` | imageToHttps" v-if="curTabId == 1 && item.type == 'all'" />
          <img :src="`${$cdnImageUrl}/search/zonghe_gray.png` | imageToHttps" v-else-if="item.type == 'all'"/>

          <img :src="`${$cdnImageUrl}/common/price_up_blue.png` | imageToHttps" v-if="item.type == 'price' && item.sort && (item.sort%2 == 1) " />
          <img :src="`${$cdnImageUrl}/common/price_down_blue.png` | imageToHttps" v-else-if="item.type == 'price' && item.sort && (item.sort%2 == 0)" />
          <img :src="`${$cdnImageUrl}/common/price_gray.png` | imageToHttps" v-else-if="item.type == 'price'" />

          <img class="img-big" :src="`${$cdnImageUrl}/search/filter_blue.png` | imageToHttps " alt="" v-if="item.type == 'filter' && fnChangeFlag">
          <img class="img-big" :src="`${$cdnImageUrl}/search/filter_gray.png` | imageToHttps" alt="" v-else-if="item.type == 'filter'">
        </div>
        <div class="category-submenu" v-show="item.subMenu && item.subMenuShow">
          <div :class="{'active': menu.subid == curSubId}" v-for="menu in item.subMenu" :key="menu.id" @click="changeTab(item, menu)">{{menu.name}}</div>
        </div>
      </div>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="slideRefresh">
      <template #pulling><refreshLoading text="下拉刷新" color="#fff" textColor="#fff"/></template>
      <template #loosing><refreshLoading text="下拉刷新" color="#fff" textColor="#fff"/></template>
      <template #loading><refreshLoading text="加载中" color="#fff" textColor="#fff"/></template>
      <template #success><refreshLoading text="加载完成" color="#fff" textColor="#fff"/></template>
        <div id="btmCateList" class="btm-category-list" v-if="productCateList.length">
          <div class="activity-tabs" v-if="activityTabs.length">
            <div v-for="item in activityTabs" :key="item.id" :class="{'active': item.id == curActiveTab}" @click="changeActivityTab(item)">优先展示{{item.tagName}}商品</div>
          </div>
          <lazy-public-product-list :skulive="productSkus" :productList="productCateList" :switchStyle='true' />
          <div id="loadFetchEle" class="loading-text">
            <div v-if="!fetchEnd">加载中...</div>
            <div v-else>没有更多了</div>
          </div>
        </div>
        <div class="category-empty" v-else-if="fetchEnd">
          <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/order/card-empty.png" alt="">
          <div class="loading-text">没有相关内容~</div>
        </div>
    </van-pull-refresh>

    <!-- 筛选框 -->
    <van-popup v-model="filterFlag" @close="onGoodsFilterHide" :style="{ width: '7rem', height: '100vh' }" position="right" get-container="#app">
      <lazy-goods-filter
        ref="filter"
        :stock="stock"
        :price="price"
        :brandList="brandList"
        :lstAttributes="lstAttributes"
        :location="location"
        @fnConfirm="fnConfirm"
        @fnFold="fnFold"
        @fnReset="fnReset"
        @fnSelect="fnSelect"
        @fnShowGoodsFilter="fnShowGoodsFilter"
        @changeAddr="changeAddr"
      />
    </van-popup>

    <van-popup v-model="addrShow" :style="{ width: '7rem', height: '100vh' }" position="right" get-container="#app">
      <!-- 地址选择列表 -->
      <lazy-addr-select v-if="addrShow" @onHide="onHideAddr" @handleLocation="handleLocation"  @otherLocation="otherLocationOption" />
    </van-popup>
    <van-popup  v-model="locationshow" :style="{ width: '7rem', height: '100vh' }" position="right" get-container="#app">
      <!-- 选择地理位置 -->
      <lazy-change-geographic-location v-if="locationshow" :isShowBack="true" :fullScreen="true" @onHide="onHideLocation" @closeAndBack="closeAndBack" @handleLocation="handleLocation" />
    </van-popup>
  </div>
</template>

<script>
// import Teleport from '@/components/teleport';
import refreshLoading from '@/components/refreshLoading'
import { mapGetters } from 'vuex'
import { getSkusLiveInfo, getSelectBoxTagList } from '@/http/service/search'
import { getPriceByProductList, wdMarketFiltrate, commonLoadItemNew } from '@/http/service/shop'
const lazyPublicProductList = () => import(/* webpackChunkName: "productList" */'@/components/publicProductList/index')
const lazyGoodsFilter = () => import(/* webpackChunkName: "goodsFilter" */'@/components/goodsFilter')
const lazyAddrSelect = () => import(/* webpackChunkName: "addrSelect" */'@/components/addressList/addr-select')
const lazyChangeGeographicLocation = () => import(/* webpackChunkName: "geographic" */'@/components/addressList/change-geographic-location')

export default {
  name: 'categorySearchList',
  props: {
    fixedTop: {
      type: String,
      default: ''
    },
    categoryName: {
      type: String,
      default: ''
    },
    parentEle: {
      type: String,
      default: '#app'
    },
    categoryId: [Number, String],
  },
  components: {
    // Teleport,
    refreshLoading,
    lazyPublicProductList,
    lazyGoodsFilter,
    lazyAddrSelect,
    lazyChangeGeographicLocation,
  },
  data() {
    return {
      isLoading: true,
      curCategoryName: this.categoryName,
      curproductCateId: this.categoryId,
      curType: 'all',
      curTabId: 1,
      curSubId: 11,
      filterTab: [
        { id: 1,
          name: '综合',
          type: 'all',
          subMenuShow: false,
          subMenu: [
            { subid: 11, name: '综合排序' },
            { subid: 12, name: '评价数从高到底' }
          ]
        },
        { id: 2, name: '销量', type: 'sale' },
        { id: 3, name: '价格', type: 'price', sort: 0 },
        { id: 4, name: '筛选', type: 'filter' },
      ],

      activityTabs: [], // 活动tab
      curActiveTab: '', // 当前活动tab

      productCateList: [],
      fetching: false,
      fetchEnd: false,
      curpage: 1,
      pageSize: 10,

      productSkus: {}, // 获取直播商品skus

      filterQs: 'isHotDesc',
      filterData: 'all@all@0',
      filterLoad: false,
      filterFlag: false,
      stock: 'all',
      price: '',
      brandList: [],
      lstAttributes: [],
      fnChangeFlag: false, // 筛选项是否被改变标记

      addrShow: false,
      locationshow: false,
    }
  },
  computed: {
    ...mapGetters({
      location: 'getlocationInfo',
    }),
    location() {
      return this.$store.getters['getlocationInfo']
    },
    memberId() {
      return sessionStorage.getItem('shareUserId') || '';
    }
  },
  watch: {
    categoryName(newVal) {
      this.curCategoryName = newVal
      console.log('curCategoryName==>', this.curCategoryName)
    },
    async categoryId(newVal) {
      this.curproductCateId = newVal
      console.log('curproductCateId==>', this.curproductCateId)
      this.fnReset()
      await this.wdMarketFiltrate()
      this.fetchInit()
    }
  },
  mounted() {
    document.getElementById('app-warp').addEventListener('scroll', this.scrollBindFn)
    // 获取活动标签信息
    this.getSelectBoxTagList()
    this.fetchData()
  },
  beforeDestroy() {
    document.getElementById('app-warp').removeEventListener('scroll', this.scrollBindFn)
  },
  methods: {
    scrollBindFn(ev) {
      let el = document.getElementById('loadFetchEle')
      if (el?.getBoundingClientRect().top < window.innerHeight + 200) {
        this.fetchData()
      }
    },
    fetchInit() {
      this.productCateList = []
      this.fetching = false
      this.fetchEnd = false
      this.curpage = 1
      this.fetchData();
    },
    fetchData() {
      console.log('fetch')
      if (this.fetching || this.fetchEnd) return
      this.fetching = true
      commonLoadItemNew({
        pholder: 1,
        productCateId: this.curproductCateId,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        districtId: this.location.districtId,
        streetId: this.location.townshipId,
        fromType: 1,
        qs: this.filterQs,
        filterData: this.filterData,
        memberId: this.memberId, // 分享人id
        pageIndex: this.curpage,
        pageSize: this.pageSize,
      }).then(res => {
        let result = res;
        if (result.success) {
          let skus = [] // 直播skus处理
          let productList = result.data.productList
          let traceId = result.data.traceId
          if (productList.length && traceId) {
            this.getPriceByProductList(traceId).then(products => {
              productList.forEach(item => {
                skus.push(item.productId);
                products.forEach(prod => {
                  if (prod.sku === item.sku) {
                    item.finalPrice = prod.lowestFlashPrice || prod.finalPrice
                    item.isLowestFlash = !!prod.lowestFlashPrice
                    item.skku = prod.skku
                    item.commission = prod.commission
                    item.commissionType = prod.commissionType
                    item.firstImageInfo = prod.firstImageInfo
                    item.priceType = prod.priceType
                    item.defaultPrice = prod.defaultPrice
                    item.promotion = prod.promotion
                    item.productActNew = prod.productActNew
                    item.productActTerm = prod.productActTerm
                    item.plusPrice = prod.plusPrice
                    item.clustersNum = prod.clustersNum
                    item.saleNum = prod.saleNum
                    item.recentCartNum = prod.recentCartNum
                    item.marketingTagList = prod.marketingTagList || []
                    item.giftCoupon = prod.giftCoupon
                    item.displayElementInfo = prod.displayElementInfo
                  }
                })
                // 活动标签
                this.activityTabs.forEach(_item => {
                  if (_item.id === item.actTagId) {
                    item.productActNew = _item.tagName
                    item.productActTerm = ''
                    item.hasTag = true
                  }
                })
              })

              this.getSkusLive(skus)
              // 存放筛选项
              if (this.brandList.length === 0 && this.lstAttributes.length === 0) {
                this.wdMarketFiltrate()
              }

              this.productCateList = this.productCateList.concat(productList)
              this.productCateList.forEach((item, index) => {
                item.listIndex = index
                item.productCateId = this.curproductCateId
              })
              this.fetching = false;
              this.curpage += 1;

              if (productList.length < this.pageSize) {
                this.fetchEnd = true
              }
              window.setTimeout(() => {
                this.createIntersectionObserver()
              }, 500)
            })
          } else {
            this.fetchEnd = true
          }
        }
      }).catch(() => {
        this.fetchEnd = true
      })
    },
    createIntersectionObserver () {
      const options = {
        root: document.querySelector('#app'),
        rootMargin: '50px 0px',
        threshold: [0.01]
      }
      if (this.IntersectionObserver) {
        this.IntersectionObserver.disconnect()
      }
      this.IntersectionObserver = new IntersectionObserver((entries) => {
        for (const ent of entries) {
          if (ent.isIntersecting) {
            this.$util.gioTrackWithVariable('MB13405', {
              // user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
              // member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
              roughly_classification_id: this.curproductCateId ? this.curproductCateId + '' : 'null',
              productId_var: ent.target.dataset.id + '',
              site_number: ~~ent.target.dataset.index + 1 + ''
            })
          }
        }
      }, options)
      for (const dom of document.querySelectorAll('.public-double-row-goods')) {
        this.IntersectionObserver.observe(dom)
      }
    },
    changeTab(item, subMenu) {
      if (this.curType === 'sale' && item.type === 'sale') return

      if (item.type === 'price') { // 价格
        this.curTabId = item.id;
        this.curType = item.type
        item.sort += 1
        this.filterQs = (item.sort % 2 === 0) ? 'priceDesc' : 'price'
      } else {
        this.filterTab[2].sort = 0
      }

      if (item.type === 'all' && !subMenu) { // 综合
        item.subMenuShow = !item.subMenuShow
      } else if (item.type === 'all') {
        item.subMenuShow = !item.subMenuShow
        if (subMenu && subMenu.subid === 12) { // 评价从高到底
          this.filterQs = 'comments'
          item.name = '评论'
        } else {
          this.filterQs = 'isHotDesc'
          item.name = '综合'
        }
        this.filterTab[0].subMenuShow = false
      }

      if (item.type === 'sale') { // 销量
        this.filterQs = 'saleDesc'
        this.curTabId = item.id;
        this.curType = item.type
      }

      if (item.type === 'filter') { // 筛选
        this.filterFlag = true
      }

      if (subMenu) {
        let isFirst = this.curSubId === subMenu.subid
        this.curTabId = item.id
        this.curSubId = subMenu.subid
        this.curType = item.type
        item.subMenuShow = false
        !isFirst && this.fetchInit()
      } else if (item.type !== 'all') {
        this.curSubId = ''
      }

      if (item.type !== 'all' && item.type !== 'filter') {
        this.fetchInit()
      }
    },
    toProduct(prod) {
      this.$router.push(`/goodsDetail?productId=${prod.productId}`)
    },

    /**
     * @description 商品筛选 确定
     */
    fnConfirm(data) {
      this.price = data.price
      let gioArr = [] // gio参数数组
      gioArr.push(this.location.region)
      gioArr.push(this.stock)
      gioArr.push(this.price)
      // 格式 库存@品牌@价格@类目特殊
      let _brand = ''
      if (this.brandList.length > 0) {
        this.brandList.forEach((item, index) => {
          if (item.selected) {
            _brand = `${_brand}${item.id};`
            gioArr.push(item.brandName)
          }
        })
        _brand = _brand.slice(0, _brand.length - 1)
      }
      let _other = []
      if (this.lstAttributes.length > 0) {
        this.lstAttributes.forEach((item, index) => {
          let _otherArr = []
          item.lstAttributeOptions.forEach(subItem => {
            if (subItem.selected) {
              _otherArr.push(subItem.id)
              gioArr.push(subItem.optionValue)
            }
          })
          _other.push(_otherArr.join(';'))
        })
      }
      this.$util.gioTrackWithVariable('MB15634', {
        filter: gioArr.join(',')
      })
      _other = _other.join(',')
      this.filterData = `${this.stock}@${_brand}@${data.price}@${_other}`
      console.log('this.filterData:', this.filterData)

      this.fetchInit()
      this.fnHasChanged()
    },

    fnFold(type) {
      this.lstAttributes.forEach(item => {
        if (item.id === type) {
          item.foldFlag = !item.foldFlag
        }
      })
      this.lstAttributes.splice(0, 1, this.lstAttributes[0]) // 强制刷新页面
    },
    /**
     * @description 商品筛选 重置
     */
    fnReset() {
      // 重置库存
      this.stock = 'all'
      // 重置价钱
      this.price = ''
      // 重置筛选项
      this.filterData = 'all@all@0'

      // 重置品牌
      if (this.brandList.length > 0) {
        this.brandList.forEach(item => {
          item.selected = false
        })
        this.brandList[0].selected = true
        this.brandList.splice(0, 1, this.brandList[0]) // 强制页面刷新
      }
      // 重置其他
      if (this.lstAttributes.length > 0) {
        this.lstAttributes.forEach((item, index) => {
          item.lstAttributeOptions.forEach((subItem, subIndex) => {
            subItem.selected = false
            if (subIndex === 0) {
              subItem.selected = true
            }
          })
        })
        this.lstAttributes.splice(0, 1, this.lstAttributes[0]) // 强制页面刷新
      }
      this.fnHasChanged()
    },
    /**
     * @description 筛选项是否有变动
     */
    fnHasChanged() {
      this.fnChangeFlag = false;
      this.$nextTick(() => {
        // 库存
        if (this.stock !== 'all') this.fnChangeFlag = true;
        // 价钱
        if (this.price !== '' && this.price !== '0') this.fnChangeFlag = true;
        // 筛选组件内最高价与最低价
        if (this.$refs.filter && (this.$refs.filter.lowestPrice || this.$refs.filter.highestPrice)) this.fnChangeFlag = true;
        // 品牌
        if (this.brandList.length > 0) {
          this.brandList.forEach((item, index) => {
            if (item.selected && index !== 0) this.fnChangeFlag = true;
          })
        }
        // 其他
        if (this.lstAttributes.length > 0) {
          this.lstAttributes.forEach((item, index) => {
            item.lstAttributeOptions.forEach((subItem, subIndex) => {
              if (subItem.selected && subIndex !== 0) this.fnChangeFlag = true;
            })
          })
        }
      })
    },
    /**
     * @description 商品筛选
     */
    fnSelect(data) {
      let _selectAll
      if (data.type === 'brand') {
        if (data.index === 0) {
          this.brandList.forEach(item => {
            item.selected = false
          })
          this.brandList[0].selected = true
        } else {
          this.brandList[0].selected = false
          this.brandList[data.index].selected = !this.brandList[data.index].selected
          const _brandList = [...this.brandList]
          _brandList.splice(0, 1)
          _selectAll = _brandList.some(item => item.selected === false)
          if (!_selectAll) {
            this.brandList.forEach(item => {
              item.selected = false
            })
            this.brandList[0].selected = true
          }
        }
        _selectAll = this.brandList.some(item => item.selected === true)
        if (!_selectAll) {
          this.brandList[0].selected = true
        }
        this.brandList.splice(data.index, 1, this.brandList[data.index]) // 强制页面刷新
      } else if (data.type === 'other') {
        if (data.subIndex === 0) {
          this.lstAttributes[data.index].lstAttributeOptions.forEach(item => {
            item.selected = false
          })
          this.lstAttributes[data.index].lstAttributeOptions[0].selected = true
        } else {
          this.lstAttributes[data.index].lstAttributeOptions[0].selected = false
          this.lstAttributes[data.index].lstAttributeOptions[data.subIndex].selected = !this.lstAttributes[data.index].lstAttributeOptions[data.subIndex].selected
          const _lstAttributeOptions = [...this.lstAttributes[data.index].lstAttributeOptions]
          _lstAttributeOptions.splice(0, 1)
          _selectAll = _lstAttributeOptions.some(item => item.selected === false)
          if (!_selectAll) {
            this.lstAttributes[data.index].lstAttributeOptions.forEach(item => {
              item.selected = false
            })
            this.lstAttributes[data.index].lstAttributeOptions[0].selected = true
          }
        }
        _selectAll = this.lstAttributes[data.index].lstAttributeOptions.some(item => item.selected === true)
        if (!_selectAll) {
          this.lstAttributes[data.index].lstAttributeOptions[0].selected = true
        }
        this.lstAttributes.splice(data.index, 1, this.lstAttributes[data.index]) // 强制页面刷新
      } else if (data.type === 'stock') {
        this.stock = data.index
      }
    },
    fnShowGoodsFilter() {
      this.filterFlag = !this.filterFlag
    },
    changeAddr() {
      this.addrShow = true
    },
    onGoodsFilterHide() {
      this.filterFlag = false
    },

    onHideAddr() {
      this.addrShow = false
    },
    handleLocation() {
      this.locationshow = false
      this.addrShow = false
    },
    otherLocationOption() {
      this.locationshow = true
    },
    onHideLocation() {
      this.locationshow = false
    },
    closeAndBack() {
      this.locationshow = false
    },

    /**
     * @description 获取商品分类项
     */
    wdMarketFiltrate() {
      wdMarketFiltrate({
        productCateId: this.curproductCateId,
        key: this.categoryName
      }).then(res => {
        if (res.success) {
          this.brandList = res.data.brandList || []

          this.lstAttributes = res.data.filterMap ? res.data.filterMap.lstAttributes : []
          // 处理数组，添加默认选中
          this.brandList.forEach((item, index) => {
            item.selected = false
            if (index === 0) {
              item.selected = true
              // 将全部的id改为 all
              item.id = 'all'
            }
          })
          // 删除 null
          let set = new Set(this.lstAttributes)
          set.delete(null)
          this.lstAttributes = Array.from(set)
          this.lstAttributes.forEach((item, index) => {
            item.foldFlag = true // 折叠
            item.lstAttributeOptions.forEach((subItem, subIndex) => {
              subItem.selected = false
              if (subIndex === 0) {
                subItem.selected = true
              }
            })
          })
        } else {
          this.$toast(res.message)
        }
      }).catch(e => { console.log(e) })
    },
    /**
     * @description 异步获取信息接口(获取商品价钱)
     */
    getPriceByProductList(traceId) {
      return new Promise((resolve, reject) => {
        getPriceByProductList({
          traceId: traceId,
        }).then(res => {
          if (res.success) {
            resolve(res.products)
          } else {
            this.$toast(res.message)
          }
        }).catch(e => console.log(e))
      })
    },
    /**
     * 通过skus获取当前是否有直播
     */
    getSkusLive(skus) {
      getSkusLiveInfo(skus).then(res => {
        let result = res.data
        console.log(result, 'result')
        // this.productSkus
        this.productSkus = {
          ...this.productSkus,
          ...result
        }
        console.log(this.productSkus, '===++++ productSkus ++++===')
      })
    },

    /**
     * 获取活动标签
     */
    getSelectBoxTagList() {
      getSelectBoxTagList().then(res => {
        let result = res.data;
        console.log(result, 'result getSelectBoxTagList')
        this.activityTabs = result || []
      }).catch(e => console.log(e))
    },
    /**
     * 活动优先展示切换
     */
    changeActivityTab(item) {
      if (this.curActiveTab === item.id) {
        this.curActiveTab = '';
      } else {
        this.curActiveTab = item.id;
      }
      console.log('changeActivityTab')
      this.doSearch()
    },

    slideRefresh(){
      this.$util.setTimeOutFn(() => {
        this.isLoading = false;
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.category-filter{
  display: flex;
  > div{
    flex: 1;
  }
}
.tab-item{
  display: flex;
  justify-content: center;
  align-items: center;
  height: .74rem;
  font-size: .26rem;
  color: #333;
  &.active{
    color: $themeSynMain;
  }
  > img{
    margin-left: .1rem;
    width: .12rem;
    &.img-big{
      width: .22rem;
    }
  }
}
.filter-fixed{
  position: fixed;
  left: 0;
  right: 0;
  z-index: 5;
  background: #fff;
  @include max-width;
}
.category-submenu{
  position: absolute;
  left: 0;
  right: 0;
  padding: 0 .32rem;
  background: #fff;
  border-radius: 0 0 .24rem .24rem;
  > div{
    font-size: .26rem;
    line-height: .8rem;
    color: grey;
    &.active{
      color: $themeSynMain;
    }
  }
}

.activity-tabs{
  padding: .22rem .24rem;
  padding-right: 0;
  white-space: nowrap;
  background: #fff;
  overflow-x: auto;
  padding-top: .04rem;
  padding-bottom: .24rem;
  div{
    margin-right: .16rem;
    display: inline-flex;
    padding: .14rem .26rem;
    color: #333;
    font-size: .22rem;
    font-weight: 400;
    border-radius: .5rem;
    background-color: #f5f5f5;
    font-family: PingFangSC, PingFangSC-Regular;
    &.active{
      color: $themeSynMain;
      background: rgba($themeSynMain,.1);
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
    }
  }
}
.category-empty{
  padding-top: 2rem;
  text-align: center;
  img{
    display: inline-block;
    max-width: 40%;
  }
}
.loading-text{
  padding: .3rem 0;
  margin-bottom: 1.2rem;
  text-align: center;
  font-size: .28rem;
  color: #969799;
}
</style>
